/**
 * Type definitions for Data Processing functionality
 */

// =============================================================================
// WORKFLOW CONFIGURATION
// =============================================================================

/** Workflow step interface */
export interface ProcessingWorkflowStep {
  id: number;
  label: string;
  description?: string;
}

/** Workflow steps for the data processing flow */
export const WORKFLOW_STEPS: ProcessingWorkflowStep[] = [
  { id: 1, label: 'workflow.steps.upload', description: 'workflow.steps.uploadDesc' },
  { id: 2, label: 'workflow.steps.parameters', description: 'workflow.steps.parametersDesc' },
  { id: 3, label: 'workflow.steps.process', description: 'workflow.steps.processDesc' },
  { id: 4, label: 'workflow.steps.save', description: 'workflow.steps.saveDesc' }
];
